export interface SideNavItem {
  label: string;
  value: any;
  iconName?: string;
  badge?: string | number;
  showBadge?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  selected?: boolean;
}

export interface SideNavGroup {
  label: string;
  items: SideNavItem[];
}

export interface SideNavUser {
  name: string;
  role: string;
  avatarSrc?: string;
  initials?: string;
}
